// extracted by mini-css-extract-plugin
export default {"restartGameWrapper":"RestartGameStyles_restartGameWrapper__j8++P","restartGame":"RestartGameStyles_restartGame__Ar+wN","fade-in-restart":"RestartGameStyles_fade-in-restart__-qGEL"};